import { render } from "./subTitle.vue?vue&type=template&id=a025f85c"
import script from "./subTitle.vue?vue&type=script&lang=js"
export * from "./subTitle.vue?vue&type=script&lang=js"

import "./subTitle.vue?vue&type=style&index=0&id=a025f85c&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/sign-log/advertising-register/step/components/subTitle.vue'],['render',render],['__file',"subTitle.vue"]])

export default __exports__